import React, { useEffect, useState } from "react";
import axios from 'axios';
import { toast } from 'react-toastify';
import moment from 'moment';
import { Button, Form, Col, Row, Modal } from 'react-bootstrap';
import { DataTable } from 'primereact/datatable';
import { Paginator } from 'primereact/paginator';
import { Column } from 'primereact/column';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { InputText } from 'primereact/inputtext';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/fluent-light/theme.css';

const category = [
  {
    "value": "Receipt Not Generated",
    "label": "Receipt Not Generated",
    "type": "Transaction"
  },
  {
    "value": "SMS Confirmation Not Received by Sender",
    "label": "SMS Confirmation Not Received by Sender",
    "type": "Transaction"
  },
  {
    "value": "Amount Not Credited to Bank Account",
    "label": "Amount Not Credited to Bank Account",
    "type": "Transaction"
  },
  {
    "value": "Beneficiary Unable to Collect Cash Payment",
    "label": "Beneficiary Unable to Collect Cash Payment",
    "type": "Transaction"
  },
  {
    "value": "Transaction Status Not Updated",
    "label": "Transaction Status Not Updated",
    "type": "Transaction"
  },
  {
    "value": "Transaction Marked as Paid but Amount Not Credited / Collected by Beneficiary",
    "label": "Transaction Marked as Paid but Amount Not Credited / Collected by Beneficiary",
    "type": "Transaction"
  },
  {
    "value": "Request for Beneficiary Name Correction",
    "label": "Request for Beneficiary Name Correction",
    "type": "Transaction"
  },
  {
    "value": "Request for Beneficiary Account Number Correction",
    "label": "Request for Beneficiary Account Number Correction",
    "type": "Transaction"
  },
  {
    "value": "Request for Cancellation of Transaction",
    "label": "Request for Cancellation of Transaction",
    "type": "Transaction"
  },
  {
    "value": "Amount Credited / Pay to Incorrect Beneficiary",
    "label": "Amount Credited / Pay to Incorrect Beneficiary",
    "type": "Transaction"
  },
  {
    "value": "Short Payment to Beneficiary",
    "label": "Short Payment to Beneficiary",
    "type": "Transaction"
  },
  {
    "value": "Service-Related Grievance",
    "label": "Service-Related Grievance",
    "type": "Transaction"
  },
  {
    "value": "General Enquiry",
    "label": "General Enquiry",
    "type": "Transaction"
  },
  {
    "value": "Unable to Create Sender",
    "label": "Unable to Create Sender",
    "type": "Sender Onboarding"
  },
  {
    "value": "OTP Not Received During Sender Creation",
    "label": "OTP Not Received During Sender Creation",
    "type": "Sender Onboarding"
  },
  {
    "value": "Error Encountered During Document Upload",
    "label": "Error Encountered During Document Upload",
    "type": "Sender Onboarding"
  },
  {
    "value": "KYC Under Review / Pending for a long time",
    "label": "KYC Under Review / Pending for a long time",
    "type": "Sender Onboarding"
  },
  {
    "value": "KYC Rejected Without Reason",
    "label": "KYC Rejected Without Reason",
    "type": "Sender Onboarding"
  },
  {
    "value": "Aadhaar Biometric Authentication Failure",
    "label": "Aadhaar Biometric Authentication Failure",
    "type": "Sender Onboarding"
  },
  {
    "value": "Request to Update Sender Information",
    "label": "Request to Update Sender Information",
    "type": "Sender Onboarding"
  },
  {
    "value": "Request to Delete Unauthorized Sender",
    "label": "Request to Delete Unauthorized Sender",
    "type": "Sender Onboarding"
  },
  {
    "value": "Technical Error During Sender Onboarding",
    "label": "Technical Error During Sender Onboarding",
    "type": "Sender Onboarding"
  },
  {
    "value": "Service-Related Grievance (Sender Onboarding)",
    "label": "Service-Related Grievance (Sender Onboarding)",
    "type": "Sender Onboarding"
  },
  {
    "value": "General Enquiry (Sender Onboarding)",
    "label": "General Enquiry (Sender Onboarding)",
    "type": "Sender Onboarding"
  },
  {
    "value": "Unable to Create Receiver",
    "label": "Unable to Create Receiver",
    "type": "Receiver Onboarding"
  },
  {
    "value": "Request to Update Receiver Information",
    "label": "Request to Update Receiver Information",
    "type": "Receiver Onboarding"
  },
  {
    "value": "Request to Delete Unauthorised Receiver",
    "label": "Request to Delete Unauthorised Receiver",
    "type": "Receiver Onboarding"
  },
  {
    "value": "Technical Error During Receiver Creation",
    "label": "Technical Error During Receiver Creation",
    "type": "Receiver Onboarding"
  },
  {
    "value": "Service-Related Grievance (Receiver Creation)",
    "label": "Service-Related Grievance (Receiver Creation)",
    "type": "Receiver Onboarding"
  },
  {
    "value": "General Enquiry (Receiver Creation)",
    "label": "General Enquiry (Receiver Creation)",
    "type": "Receiver Onboarding"
  }
];

function Complaint() {
  const [errors, setErrors] = useState(false);
  const [data, setData] = useState(false);
  const [pageData, setPageData] = useState(false);
  const [loading, setLoading] = useState(false);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [trackComplaintData, setTrackComplaintData] = useState(false);
  const [complaintType, setComplaintType] = useState(false);
  const [addModal, setAddModal] = useState(false);
  const [trackComplaintModal, setTrackComplaintModal] = useState(false);

  const header = (
    <div className="flex flex-wrap gap-2 align-items-center justify-content-between">
      <IconField iconPosition="right">
        <InputIcon className="pi pi-search" />
        <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Search..." />
      </IconField>
    </div>
  );

  const handleClose = () => {
    setAddModal(false);
    setTrackComplaintModal(false);
  }

  const registerComplaintSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    let jsonData = {};
    let errorData = {};
    Array.from(form.elements).forEach((item) => {
      if (item.name) {
        if (item.value == "" && item.getAttribute("requiredField")) {
          errorData[item.name] = [addSpaceBetweenCases(item.name)] + " is required";
        }
        jsonData[item.name] = item.value;
      }
    });
    if (Object.entries(errorData).length > 0) {
      setErrors(errorData);
    }
    else {
      try {
        const response = await axios.post('/prabhuRemittance/registerComplaint', jsonData);
        const { status, message, complainId } = response.data;
        if (status) {
          setAddModal(false);
        }
        toast(message);
      } catch (error) {
        if (error?.response?.data?.message) {
          toast(error.response.data.message);
        }
      }
    }
  };

  const handleSearch = async (e) => {
    e.preventDefault();
    try {
      const { complaintId } = e.target;
      let requestData = {
        complaintId: complaintId.value
      };
      const response = await axios.post("/history/getComplaints", requestData);
      const { status, data, body, first, rows, totalRecords } = response.data;
      if (status) {
        setData(response.data);
        setPageData({ ...body, first, rows, totalRecords });
        setLoading(false);
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };

  function addSpaceBetweenCases(str) {
    return str.replace(/([a-z])([A-Z])/g, '$1 $2');
  };

  const trackComplaint = async (complaintId) => {
    const response = await axios.post("/prabhuRemittance/trackComplaint", { complaintId });
    const { status, message, complains } = response.data;
    if (status) {
      toast(message);
      setTrackComplaintData(complains);
      setTrackComplaintModal(true);
    }
  };

  const fetchData = async (event) => {
    let rechargeData = {
      first: event.first,
      rows: event.rows,
      complaintId: pageData.complaintId,
      //start_date: pageData.start_date,
      //end_date: pageData.end_date,
    };
    getData(rechargeData);
  };

  const getData = async (requestData = {}) => {
    try {
      setLoading(true);
      const response = await axios.post("/history/getComplaints", requestData);
      const { status, data, body, first, rows, totalRecords } = response.data;
      if (status) {
        setData(response.data);
        setPageData({ ...body, first, rows, totalRecords });
        setLoading(false);
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <div class="content-wrapper">
      <div class="row">
        <div class="col-lg-12 grid-margin stretch-card">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">
                Complaint
                <button type="button" className="float-right btn btn-primary" onClick={(e) => setAddModal(true)}>Register Complaint</button>
              </h4>
              <form className="searchForm" onSubmit={handleSearch}>
                <div class="row">
                  <div class="col-lg-6 col-md-6">
                    <label for="complaintId">Complaint ID</label>
                    <input class="form-control" type="text" name="complaintId" required />
                  </div>
                  <div class="col-lg-6 col-md-6">
                    <input type="submit" className="search-btn btn btn-primary" value="Search" />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="col-lg-12 grid-margin stretch-card">
          <div class="card">
            <div class="card-body">
              {
                data && (
                  <>
                    <h4 class="card-title">
                      Notices
                    </h4>
                    <DataTable
                      value={data.data}
                      size="small"
                      editMode="cell"
                      globalFilter={globalFilter}
                      header={header}
                      className="custom-table" // Add custom class here
                      loading={loading}
                    >
                      <Column
                        field="index"
                        header="#"
                        sortable
                        body={(rowData, { rowIndex }) => <span data-label="#">{pageData?.first + rowIndex + 1}</span>}
                      />
                      <Column
                        field="created_at"
                        header="Date"
                        sortable
                        body={(rowData) => <span data-label="Date">{moment(rowData.created_at).format('MMM-DD-YYYY')}<br />{moment(rowData.created_at).format('hh:mm:ss A')}</span>}
                      />
                      <Column
                        field="complainId"
                        header="ComplainId"
                        sortable
                        body={(rowData) => <span data-label="ComplainId">{rowData?.complainId}</span>}
                      />
                      <Column
                        field="complaintType"
                        header="ComplaintType"
                        sortable
                        body={(rowData) => <span data-label="ComplaintType">{rowData?.complaintType}</span>}
                      />
                      <Column
                        field="mobileNumber"
                        header="MobileNumber"
                        sortable
                        body={(rowData) => <span data-label="MobileNumber">{rowData?.mobileNumber}</span>}
                      />
                      <Column
                        field="referenceNumber"
                        header="ReferenceNumber"
                        sortable
                        body={(rowData) => <span data-label="ReferenceNumber">{rowData?.referenceNumber}</span>}
                      />
                      <Column
                        field="ticketType"
                        header="TicketType"
                        sortable
                        body={(rowData) => <span data-label="TicketType">{rowData?.ticketType}</span>}
                      />
                      <Column
                        field="category"
                        header="Category"
                        sortable
                        body={(rowData) => <span data-label="Category">{rowData?.category}</span>}
                      />
                      <Column
                        field="remarks"
                        header="Remarks"
                        sortable
                        body={(rowData) => <span data-label="Remarks">{rowData?.remarks}</span>}
                      />
                      <Column
                        field="action"
                        header="Action"
                        sortable
                        body={
                          (rowData) => (
                            <span data-label="Action">
                              <button className="btn btn-primary" onClick={(e) => trackComplaint(rowData?.complainId)}>Track</button>
                            </span>
                          )
                        }
                      />
                    </DataTable>
                    <div className="card">
                      <Paginator first={pageData && pageData.first} rows={pageData && pageData.rows} totalRecords={pageData && pageData.totalRecords} rowsPerPageOptions={[5, 10, 20, 30, 40, 50, 100, 200, 300, 400, 500, 1000]} onPageChange={fetchData} />
                    </div>
                  </>
                )
              }
            </div>
          </div>
        </div>
      </div>
      <Modal show={addModal} onHide={handleClose} centered size={'xl'} backdrop="static">
        <Form onSubmit={registerComplaintSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>Register Complaint</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row justify-content-center">
              <div className="col-md-12">
                <div className="row">
                  <div className="col-lg-4 col-md-4">
                    <label>Complaint Type</label>
                    <select className="form-control" name="complaintType" requiredField="true" onChange={(e) => setComplaintType(e.target.value)}>
                      <option value="">--Select--</option>
                      <option value="Transaction">Transaction</option>
                      <option value="Sender Onboarding">Sender Onboarding</option>
                      <option value="Agent Onboarding">Agent Onboarding</option>
                      <option value="Receiver Onboarding">Receiver Onboarding</option>
                    </select>
                    <span className="error">{errors && errors?.complaintType}</span>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label>Sender Mobile Number</label>
                    <input className="form-control" type="number" name="mobileNumber" requiredField="true" />
                    <span className="error">{errors && errors?.mobileNumber}</span>
                  </div>
                  {complaintType == "Transaction" && (
                    <div className="col-lg-4 col-md-4">
                      <label>Transaction PIN</label>
                      <input className="form-control" type="text" name="referenceNumber" requiredField="true" />
                      <span className="error">{errors && errors?.referenceNumber}</span>
                    </div>
                  )}
                  <div className="col-lg-4 col-md-4">
                    <label>Ticket Type</label>
                    <select className="form-control" name="ticketType" requiredField="true">
                      <option value="">--Select--</option>
                      <option value="Query">Query</option>
                      <option value="Complain">Complain</option>
                    </select>
                    <span className="error">{errors && errors?.ticketType}</span>
                  </div>
                  <div className="col-lg-4 col-md-4">
                    <label>Category</label>
                    <select className="form-control" name="category" requiredField="true">
                      <option value="">--Select--</option>
                      {category.map((item) => {
                        if (item.type === complaintType) {
                          return (
                            <option key={item.value} value={item.value}>
                              {item.label}
                            </option>
                          );
                        }
                        return null;
                      })}
                    </select>
                    <span className="error">{errors && errors?.category}</span>
                  </div>
                  <div className="col-lg-12 col-md-12">
                    <label>Remarks</label>
                    <textarea className="form-control" name="remarks" requiredField="true" />
                    <span className="error">{errors && errors?.remarks}</span>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button type="submit" variant="primary">
              {'Create Complaint'}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
      <Modal show={trackComplaintModal} onHide={handleClose} centered size={'xl'} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Track Complaint</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row justify-content-center">
            <div className="col-md-12">
              <div className="row">
                <div className="col-md-12">
                  {(trackComplaintData && (Object.entries(trackComplaintData).length > 0)) && (
                    <>
                      <ul className="showData">
                        {Object.entries(trackComplaintData[0]).map(([key, value]) => (
                          (value != "" && value != null) && (
                            <li key={key}>
                              <strong>{addSpaceBetweenCases(key)}:</strong>
                              <div>{value}</div>
                            </li>
                          )))}
                      </ul>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default Complaint;
